export default __webpack_public_path__ + "static/anibot-1acb2caafcea28f64d98d69d8d847f08.gif";